module.exports = __webpack_public_path__ + "images/application/icon-streams-714a7f02.svg";